import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v9h10V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 13v9h10v-9H7z"
})), 'Battery50Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Battery50Sharp.js
// module id = 2256
// module chunks = 2